import React from 'react'
import Modal from '../modal'

type Props = {
  open: boolean
  workerName: string
  onRevert: () => void
  onCancel: () => void
}

const RevertWorkerModal: React.FC<Props> = ({ open, workerName, onRevert, onCancel }) => {
  return (
    <Modal open={open}>
      <div className='flex flex-col gap-4'>
        <h2 className='text-lg font-semibold'>Revert Worker Status</h2>
        <p className='text-sm text-gray-600'>
          Are you sure you want to revert <span className='font-medium'>{workerName}</span> from "Out" status?
        </p>
        <div className='flex gap-3 justify-end pt-2'>
          <button
            onClick={onCancel}
            className='px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors'
          >
            Cancel
          </button>
          <button
            onClick={onRevert}
            className='px-4 py-2 text-sm font-medium text-white bg-blue-700 hover:bg-blue-800 rounded-md transition-colors'
          >
            Revert
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default RevertWorkerModal
